/* unplugin-vue-components disabled */
import AddOutput from './add-output.vue'
import {MAX_OUTPUT_FIELDS} from './test-agents-defs'

export default {
  components: {AddOutput},
  mixins: [ModelValue(Object)],
  data() {
    return {
      max_output_fields: MAX_OUTPUT_FIELDS
    }
  },
  computed: {
    output_entries() {
      return Object.entries(this.value || {}).map(([name, output]) => {
        const field = typeof output === 'string' ? {type: output} : output
        return {
          name,
          type: field.type,
          optional: !!field.optional,
          description: field.description || ''
        }
      })
    }
  },
  methods: {
    addOutput() {
      this.$refs.editor.open()
    },
    saveOutput(entry, index) {
      const entries = [...this.output_entries]
      if (index === undefined) entries.push(entry)
      else entries[index] = entry
      this.value = Object.fromEntries(entries.map(({name, ...output}) => [name, output]))
    },
    removeOutput(index) {
      this.value = Object.fromEntries(this.output_entries
        .filter((_, idx) => idx !== index)
        .map(({name, ...output}) => [name, output]))
    }
  }
}
